const getters = {
  getAllUsers: (state) => state.usersList.data,
  getAllUsersStatus: (state) => state.usersList.status.pending,
};

export default getters;
